import React from "react";

export default function SchoolMapLocation() {
    return (
        <section>
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3425.83446850087!2d75.98485037638852!3d30.83530407453502!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391077342f4e933f%3A0x17f8ce846f0065fc!2sGovernment%20Senior%20Secondary%20Smart%20School%20-%20Boys!5e0!3m2!1sen!2sin!4v1727973439418!5m2!1sen!2sin"
                width="100%"
                height="450"
                loading="lazy"
                title="School Map"
            ></iframe>
        </section>
    );
}
